import { getItemsFromCollection } from "directus/src/operations";

export const getCompetencyGroups = async () => {
  try {
    const query = {
      fields: [
        "id",
        "name",
        { competencies: ["id", "title", "status", "key"] },
      ],
    };
    const response = await getItemsFromCollection("competency_groups", query);
    return response;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const getCompetencyGradeExpectations = async (grade) => {
  try {
    const normalizedGrade = grade?.toLowerCase();

    const response = await getItemsFromCollection(
      "competency_grade_expectations",
      {
        filter: {
          grade: {
            _eq: normalizedGrade,
          },
        },
        fields: [
          "*",
          "competency.id",
          "competency.title",
          "competency.status",
          "competency.group.id",
          "competency.group.name",
        ],
      }
    );

    return response || [];
  } catch (error) {
    console.error("Error fetching competency grade expectations:", error);
    throw error;
  }
};

export const getCompetencyGradeExpectationsByGroup = async (grade, groupId) => {
  try {
    // Convert grade to lowercase to match database format
    const normalizedGrade = grade?.toLowerCase();

    // console.log(
    //   "API - fetching competencies for grade:",
    //   normalizedGrade,
    //   "group:",
    //   groupId
    // );

    const response = await getItemsFromCollection(
      "competency_grade_expectations",
      {
        filter: {
          grade: {
            _eq: normalizedGrade,
          },
          competency: {
            group: {
              _eq: groupId,
            },
          },
        },
        fields: [
          "*",
          "competency.id",
          "competency.title",
          "competency.key",
          "competency.status",
        ],
      }
    );
    // console.log("API - group response:", response);
    return response || [];
  } catch (error) {
    console.error(
      "Error fetching competency grade expectations by group:",
      error
    );
    throw error;
  }
};
